import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=656fd18a"
import script from "./Messaging.vue?vue&type=script&setup=true&lang=js"
export * from "./Messaging.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=656fd18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports